import store from './index.js';

export const getDataFromStore = (section) => {
    return store.getState()[section];
}
